<script setup lang="ts">
import { defineAsyncComponent } from 'vue';
import { renderToastMessage } from '@/utils/toastMessage';

const CallManagement = defineAsyncComponent(() => import('@/components/core/home/call-management/template/CallManagement.vue'));
const ScreenShareHTML = defineAsyncComponent(() => import('@/components/core/home/chat-management/molecules/ScreenShareHTML.vue'));
const TabsManagement = defineAsyncComponent(() => import('@/components/core/home/tabs-management/template/TabsManagement.vue'));
const TaskPopUp = defineAsyncComponent(() => import('@/components/core/home/call-management/atoms/TaskpopUp.vue'));
</script>

<template>
  <q-page class="q-pa-md">
    <ToastMessage
      v-if="renderToastMessage"
    />
    <CallManagement />
    <ScreenShareHTML />
    <TabsManagement />
    <TaskPopUp />
  </q-page>
</template>